import { render, staticRenderFns } from "./share-groupbuy-store-title.vue?vue&type=template&id=098ef482&scoped=true&"
import script from "./share-groupbuy-store-title.vue?vue&type=script&lang=js&"
export * from "./share-groupbuy-store-title.vue?vue&type=script&lang=js&"
import style0 from "./share-groupbuy-store-title.vue?vue&type=style&index=0&id=098ef482&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ef482",
  null
  
)

export default component.exports